import store from "../../core/redux/Store";

const Analytics = () => {
    const analyticsFactory = {};

    const localStore = store.getState();

    analyticsFactory.currentPage = null;

    function getBrandShortHand(brand) {
        switch (brand.toUpperCase()) {
            case 'CHEVROLET':
            case 'CHEVY':
                return 'ch';
            case 'CADILLAC':
            case 'CAD':
                return 'ca';
            case 'GMC':
                return 'gmc';
            case 'BUICK':
                return 'bu';
            case 'DEALER WEBSITE':
                return 'dealer';
            case 'OWNER CENTER':
                return 'oc';
            default:
                return 'crossbrand-experience-gm';
        }
    }

    function getPageName(pageName, brand) {
        return `${getBrandShortHand(
            brand
        )}:na:us:en:t1:certified-service:tirefinder:${pageName.toLowerCase()}`;
    }

    function getSeoPageName(pageName) {
        let prettyName = '';

        switch (pageName) {
            case 'find-tires':
                prettyName = 'Find New Tires';
                break;
            case 'find-tire-widget':
                prettyName = 'Find New Tires (Widget)';
                break;
            case 'dealer-locator':
                prettyName = 'Choose a Dealer';
                break;
            case 'search-results':
                prettyName = 'Results';
                break;
            case 'compare':
                prettyName = 'Compare Tires';
                break;
            case 'product-detail':
                prettyName = 'Product Details';
                break;
            case 'view-cart':
                prettyName = 'Cart';
                break;
            case 'email':
                prettyName = 'Send Email';
                break;
            default:
                prettyName = 'Unknown page';
                break;
        }

        return `Tire Finder | ${prettyName}`;
    }

    function getDevice() {
        // if (ossDevice.isMobile) {
        //     return 'small';
        // } else if (ossDevice.isTablet) {
        //     return 'medium';
        // } else {
        //     return 'large';
        // }
        return '';
    }

    function getDealerInfo(pageName) {
        const dealerInfo = {
            bac: '',
            dealerName: '',
            dealerID: '',
        };

        if (localStore.dealerReducer.bac !== 999999) {
            dealerInfo.bac = localStore.dealerReducer.bac;
        }
        if (dealerInfo.bac) {
            const tempDealer = localStore.dealerReducer.dealers.find(d => d.bac = dealerInfo.bac);
            if (tempDealer) {
                dealerInfo.dealerName = tempDealer.dealerName;
            }
        }

        return dealerInfo;
    }

    function getVehicleInfo() {
        const vehicleInfo = {};
        vehicleInfo.vehicleMake = localStore.yearMakeModelReducer.sMake;
        vehicleInfo.modelName = localStore.yearMakeModelReducer.sModel;
        vehicleInfo.modelYear = localStore.yearMakeModelReducer.sYear;
        vehicleInfo.bodyStyle = '';
        vehicleInfo.trimLevel = localStore.yearMakeModelReducer.sTrim;
        vehicleInfo.vehicleType = '';
        vehicleInfo.zipcode = localStore.yearMakeModelReducer.zipcode;
        return vehicleInfo;
    }

    function getSearchResultLength() {
        return localStore.searchResultReducer.filteredResults.length;
    }

    analyticsFactory.trackError = function (pageName, errorMessage) {
        console.log(`ANALYTICS trackError:${pageName}`);
        trackPageAndEvent(pageName, errorMessage);
        console.log(`Calling the Analytics Track Error:${pageName}`);
    };

    analyticsFactory.trackPage = function (pageName) {
        console.log(`ANALYTICS trackPage:${pageName}`);
        trackPageAndEvent(pageName, null);
        console.log(`Calling the Analytics Track Page:${pageName}`);
    };

    analyticsFactory.trackAppointmentSubmissionPageAndEvent = function (pageName) {
        console.log(`ANALYTICS trackSubmission:${pageName}`);
        trackPageAndEvent(pageName);
        console.log(`Calling the Analytics Track Submission:${pageName}`);
    };

    function trackPageAndEvent(pageName, errorMessage) {
        console.log('in the track page function');

        const brand = localStore.appParamsReducer.brand;
        analyticsFactory.currentPage = pageName;
        const completePageName = getPageName(pageName, brand);
        const dealerInfo = getDealerInfo(pageName);
        const searchResultLength = getSearchResultLength();
        const vehicleInfo = getVehicleInfo();

        const siteSectionsL1 = 'owners';
        const siteSectionsL2 = 'certified-service';
        const siteSectionsL3 = 'tirefinder';
        const siteSectionsL4 = pageName;
        const siteSectionsL5 = `${siteSectionsL1}:${siteSectionsL2}:${siteSectionsL3}:${siteSectionsL4}`;

        const seoPageName = getSeoPageName(pageName);

        window.digitalData = {
            pageInfo: {
                pageName: completePageName,
                siteSectionsLevel1: siteSectionsL1,
                siteSectionsLevel2: siteSectionsL2,
                siteSectionsLevel3: siteSectionsL3,
                siteSectionsLevel4: siteSectionsL4,
                siteSectionsLevel5: siteSectionsL5,
                url: window.location !== window.parent.location ? document.referrer : document.location.href,
                seoStrategyPageName: seoPageName,
                pageType: 'tools',
                language: 'en',
                siteName: 'tire finder',
                brand: brand,
                country: 'united states',
                region: 'north america',
                renderedExperience: getDevice(),
                viewport: `${window.innerWidth}x${window.innerHeight}`,
                orientation: window.innerWidth > window.innerHeight ? 'Landscape' : 'Portrait'
            },
            internalCampaignInfo: {
                internalSearchNumberOfResults: searchResultLength
            },
            toolsInfo: {
                dealerBac: dealerInfo.bac,
                dealerName: dealerInfo.dealerName,
                dealerID: dealerInfo.ID,
            },
            vehicleInfo: {
                vehicleType: vehicleInfo.vehicleType,
                vehicleMake: vehicleInfo.vehicleMake,
                modelName: vehicleInfo.modelName,
                modelYear: vehicleInfo.modelYear,
                bodyStyle: vehicleInfo.bodyStyle,
                trimLevel: vehicleInfo.trimLevel,
            },
            visitorProfile: {
                zipcode: vehicleInfo.zipcode
            }
        };
    }

    return analyticsFactory;
};

export default Analytics;
